<template>
  <main class="h-full fond1  flex justify-center">
    <div class="w-full lg:aspect-[17/7] relative max-w-[2200px] mx-auto">
      <div class="w-full inset-0 absolute top-[5%] lg:top-[10%]">
        <img src="@/assets/images/logo.png" class="lg:w-[15%] w-[50%] mx-auto" />
      </div>
 
      <div class="w-full inset-0 absolute top-[10%] lg:block hidden">
        <img src="@/assets/images/2oies.png" class="w-[80%] mx-auto" />
      </div>
      <div
        class="bg-white/20 w-[90%] lg:w-[35%] lg:absolute lg:top-[25%] mt-[45%] lg:mt-0 lg:top-[35%] lg:left-1/2 lg:-translate-x-1/2 formu backdrop-blur-sm py-[5%] mx-[5%] lg:mx-0 mb-[5%]  lg:mb-0lg:px-[1%] lg:py-[2%]"
      >
   
        <img src="@/assets/images/texthome.png" class="w-full lg:block hidden" />
        <img src="@/assets/images/texthome-mob.png" class="w-[80%] lg:hidden mx-auto " />
        <form @submit.prevent="verifierAge" class="w-full block py-[5%] text-center">
          <input
            v-model="anneeNaissance"
            type="number"
            placeholder="YYYY"
            class="mx-auto lg:w-[40%] w-[75%] text-[6vw] lg:text-[2vw] 2xl:text-3xl !py-[2%] lg:py-0 text-center text-white border border-white font-grey-goose-natural"
       
            required
          /><br />
          <button
            type="submit"
            class="bg-white block w-[75%] lg:w-[40%] text-[6vw] lg:text-[1.8vw] my-[5%] lg:my-[2%] 2xl:text-3xl mx-auto text-black py-[1%] font-grey-goose-natural"
          >
            ENTRER
          </button>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      anneeNaissance: '',
      imagesToPreload: [
        require('@/assets/images/fond-mob-min.jpg'),
        require('@/assets/images/texthome-mob.png'),
        require('@/assets/images/visu-mob.png'),
        require('@/assets/images/textbravo-mob.png'),
        require('@/assets/images/text-oups-mob.png'),
        require('@/assets/images/text-finish-mob.png'),
        require('@/assets/images/home2-mob.png'),
        require('@/assets/images/texthome.png'),
        require('@/assets/images/textbravo.png'),
        require('@/assets/images/text-oups.png'),
        require('@/assets/images/text-finish.png'),
        require('@/assets/images/home2.png'),
        require('@/assets/images/logo.png'),
        require('@/assets/images/g.png'),
        require('@/assets/images/fondnew-min.jpg'),
        require('@/assets/images/fond2.jpg'),
        require('@/assets/images/fond1.jpg'),
        require('@/assets/images/2oies.png')
      ]
    }
  },
  methods: {
    preloadImages() {
      this.imagesToPreload.forEach(imagePath => {
        const img = new Image()
        img.src = imagePath
        img.onload = () => {
         
        }
        img.onerror = (error) => {
          console.error(`Erreur de chargement de l'image: ${imagePath}`, error)
        }
      })
    },
    verifierAge() {
      const anneeActuelle = new Date().getFullYear()
      const age = anneeActuelle - this.anneeNaissance
      
      if (age >= 18) {
        localStorage.setItem('age', age.toString())
        this.$router.push('/home2')
      } else {
        alert('Vous devez être majeur pour accéder à ce site')
      }
    }
  },
  mounted() {
    localStorage.removeItem('age')
    this.preloadImages()
  }
}
</script>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>